import FourXXError from 'common/components/molecules/4XXError/FourXXError';

type FourOhFourProps = {
  message?: string;
};

export const FourOhFour = ({ message = 'Page not found' }: FourOhFourProps) => (
  <FourXXError message={message} error="404"></FourXXError>
);
